<mat-tab-group>
  <mat-tab label="Dans le périmètre">
    <base-data-table-header
      [canCreate]="false"
      [canEdit]="false"
      [canImport]="false"
      [canExport]="false"
      [searchWidthFull]="true"
      [loading]="loading"
      [showSelectionActions]="true"
      [selectionCountOnRight]="true"
      [selectedCount]="selectedCount"
      [totalCount]="countIn"
      [selectAllDisabled]="countIn === 0"
      [clearSelectionDisabled]="selectedCount === 0"
      (selectAllAcrossPages)="selectAllInPerimeter()"
      (clearSelection)="clearAllSelections()"
      (onSearchChange)="onSearchChange($event)"
      (onClearTextFilter)="clearTextFilter()"
      (search)="onSearchChange($event)"
    ></base-data-table-header>

    <div class="relative">
      <base-data-table
        [dataSource]="inPerimeterDataSource"
        [displayedColumns]="displayedColumns"
        [feisColumns]="feisColumns"
        [stickyTop]="true"
        [showPaginator]="true"
        [canSelectMultiple]="true"
        (onSelectedRow)="selectRow($event, true)"
        (onRowClick)="openEngagement($event)"
        (onPageEvent)="onPageEventIn($event)"
        (onSortEvent)="sortEvent($event)"
        [selectedRows]="selectedIn"
        [count]="countIn"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [sortField]="sortField"
        [sortOrder]="sortOrder"
      ></base-data-table>
      <div *ngIf="loading" class="table-overlay">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Hors périmètre">
    <base-data-table-header
      (onSearchChange)="onSearchChange($event)"
      (onClearTextFilter)="clearTextFilter()"
      (search)="onSearchChange($event)"
      [canCreate]="false"
      [canEdit]="false"
      [canImport]="false"
      [canExport]="false"
      [loading]="loading"
    ></base-data-table-header>
    <div class="relative">
      <base-data-table
        [dataSource]="outPerimeterDataSource"
        [displayedColumns]="displayedColumns"
        [canSelectCheckBoxRows]="false"
        [feisColumns]="feisColumns"
        [stickyTop]="true"
        [showPaginator]="true"
        (onRowClick)="openEngagement($event)"
        (onPageEvent)="onPageEventOut($event)"
        (onSortEvent)="sortEvent($event)"
        [count]="countOut"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [sortField]="sortField"
        [sortOrder]="sortOrder"
      ></base-data-table>
      <div *ngIf="loading" class="table-overlay">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
